// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__36Poj","tabsBox":"styles_tabsBox__2kwm3","createButton":"styles_createButton__2miTA"};